import { render, staticRenderFns } from "./LabsView.vue?vue&type=template&id=85b7253c&scoped=true&"
import script from "./LabsView.vue?vue&type=script&lang=ts&"
export * from "./LabsView.vue?vue&type=script&lang=ts&"
import style0 from "./LabsView.vue?vue&type=style&index=0&id=85b7253c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b7253c",
  null
  
)

export default component.exports